<template>
  <div class="authorization-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <p class="label">系统：</p>
              <el-select
                v-model="filter.sys"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in system"
                  :key="item.value"
                  :label="item.labelName"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- <div class="filter-item">
              <div class="label">用户身份：</div>
              <el-select
                v-model="filter.level"
                size="small"
                class="select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in role"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="filter-item">
              <div class="label">用户ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <!-- <div class="filter-item">
              <div class="label">手机号：</div>
              <el-input
                class="input"
                v-model="filter.phone"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div> -->
            <!-- <div class="filter-item">
              <div class="label">开通时间：</div>
              <el-date-picker
                v-model="date"
                type="datetimerange"
                align="right"
                unlink-panels
                class="date-input"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                size="small"
              >
              </el-date-picker>
            </div> -->
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div style="display: flex;align-items: center;">
            <div>
              <div>
                <span style="margin-right: 24px;"
                  >店主身份金额(元)：{{ vipAmount }}</span
                >
                <span style="margin-right: 24px;"
                  >代理商身份金额(元)：{{ topAmount }}</span
                >
                <button
                  class="import-btn btn"
                  style="margin-right: 64px"
                  @click="addQuotaModal"
                >
                  设置金额
                </button>
              </div>
              <div>
                <span style="margin-right: 24px;"
                  >店主身份积分: {{ vipIntegral }}</span
                >
                <span style="margin-right: 24px;"
                  >代理商身份积分：{{ topIntegral }}</span
                >
                <button
                  class="import-btn btn"
                  style="margin: 5px;margin-right: 64px"
                  @click="addIntergralModal"
                >
                  设置积分
                </button>
              </div>
            </div>
            <button class="authorization-btn" @click="authorizationModal">
              开通身份
            </button>
          </div>
        </div>
        <el-table
          :data="userList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="sys" align="center" label="系统">
            <div slot-scope="scope">
              {{ systemMap[scope.row.sys] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="uid"
            align="center"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="用户昵称"
          ></el-table-column>
          <el-table-column prop="role" align="center" label="身份">
            <div slot-scope="scope">
              {{ roleMap[scope.row.roleTypeOne] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="vipNum"
            align="center"
            label="店主名额数"
          ></el-table-column>
          <el-table-column
            prop="topNum"
            align="center"
            label="代理商名额数"
          ></el-table-column>
          <el-table-column
            prop="operatorId"
            align="center"
            label="开通人ID"
          ></el-table-column>
          <el-table-column prop="created" align="center" label="开通日期">
            <div slot-scope="scope">
              {{ scope.row.openTime | dateFormat }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="240">
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="handleVipModal(scope.row.uid, scope.row.vipNum, 1)"
              >
                店主名额
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleTopModal(scope.row.uid, scope.row.topNum, 2)"
              >
                代理商名额
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="authorizationShow"
      class="dialog"
      width="618px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">开通身份</div>
      <el-form
        ref="form"
        :rules="rules"
        :model="authorizationForm"
        class="authorization-form"
        label-width="auto"
      >
        <el-form-item label="用户ID：" prop="uid" class="form-item">
          <input
            placeholder="输入用户ID"
            class="input"
            v-model.number="authorizationForm.uid"
            type="number"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
        </el-form-item>
        <el-form-item label="开通身份：" prop="level" class="form-item">
          <el-select
            v-model.number="authorizationForm.newRole"
            class="select"
            placeholder="请选择"
            style="width: 185px"
            size="small"
          >
            <el-option
              v-for="item in vipTop"
              :key="item.value"
              :label="item.labelName"
              :value="+item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="VIP名额" prop="overTime" class="form-item">
          <input
            placeholder="请输入"
            class="input"
            v-model.number="authorizationForm.vip"
            type="number"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
        </el-form-item>
        <el-form-item label="代理商名额" prop="overTime" class="form-item">
          <input
            placeholder="请输入"
            class="input"
            v-model.number="authorizationForm.top"
            type="number"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="authorizationShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAuthorization"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="修改店主名额"
      :visible.sync="visible1"
      width="480px"
      class="dialog"
    >
      <el-form ref="form" class="add-hz-form" label-width="100px">
        <el-form-item label="店主名额" prop="company">
          <input
            class="form-input"
            v-model.number="vipNum"
            placeholder="请输入店主名额"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="visible1 = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="handleConfirm1"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改代理商名额"
      :visible.sync="visible2"
      width="480px"
      class="dialog"
    >
      <el-form ref="form" class="add-hz-form" label-width="100px">
        <el-form-item label="代理商名额" prop="company">
          <input
            class="form-input"
            v-model.number="topNum"
            placeholder="请输入代理商名额"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="visible2 = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="handleConfirm2"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改身份金额"
      :visible.sync="visible3"
      width="480px"
      class="dialog"
    >
      <el-form ref="form" class="add-hz-form" label-width="150px">
        <el-form-item label="店主身份金额" prop="vipAmount">
          <input
            class="form-input"
            v-model.number="vipAmount"
            style="width: 180px;"
            placeholder="请输入店主身份金额"
          />
        </el-form-item>
        <el-form-item label="代理商身份金额" prop="topAmount">
          <input
            class="form-input"
            v-model.number="topAmount"
            style="width: 180px;"
            placeholder="请输入代理商身份金额"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="visible3 = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="handleConfirm3"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改身份积分"
      :visible.sync="intergralVisible"
      width="480px"
      class="dialog"
    >
      <el-form ref="form" class="add-hz-form" label-width="150px">
        <el-form-item label="店主身份赠送积分" prop="vipIntegral">
          <input
            class="form-input"
            v-model.number="vipIntegral"
            style="width: 180px;"
            placeholder="请输入店主身份赠送积分"
          />
        </el-form-item>
        <el-form-item label="代理商身份赠送积分" prop="topIntegral">
          <input
            class="form-input"
            v-model.number="topIntegral"
            style="width: 180px;"
            placeholder="请输入代理商身份赠送积分"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="intergralVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="handleConfirmIntergral"
        >
          确 定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'authorization',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '店主和代理商管理'
      },
      filter: {
        // 过滤条件
        uid: null,
        level: -1,
        phone: ""
      },
      userList: [], // 用户列表
      date: [],
      authorizationShow: false,
      rules: {
        uid: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
        newRole: [{ required: true, message: '请选择身份', trigger: 'change' }]
        // superior: [{ required: true, message: '请输入上一级ID', trigger: 'blur' }]
      },
      authorizationForm: {
        uid: null,
        newRole: null,
        vip: null,
        top: null
      },
      uid: null,
      system: [],
      systemMap: {},
      role: [],
      roleMap: {},
      vipTop: [],
      vipTopMap: {},
      visible1: false,
      visible2: false,
      visible3: false,
      vipNum: null,
      topNum: null,
      vipAmount: null,
      topAmount: null,
      vipIntegral: null,
      topIntegral: null,
      way: null,
      intergralVisible: false
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      if (date === '0000-00-00 00:00:00') return '永久';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 获取列表
    this.getList();
    this.getDictionary();
    this.getInfo();
    // this.getArea();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 获取用户列表
    getList() {
      // this.date = this.date || [];
      // this.filter.start = this.date[0] || '';
      // this.filter.end = this.date[1] || '';
      console.log(this.filter);
      this.loading++;
      this.httpGet(this.$root.getVipList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.userList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('role');
      this.getDictionaryByName('system');
      this.getDictionaryByName('vipTop');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getList();
    },
    // 重置
    reset() {
      this.filter = {
        // 过滤条件
        uid: null,
        level: -1,
        phone: ""
      };
      this.date = [];
      this.getList();
    },

    authorizationModal() {
      this.authorizationForm = {
        uid: null,
        newRole: null,
        top: null,
        vip: null
      };
      this.$refs.form && this.$refs.form.clearValidate();
      this.authorizationShow = true;
    },
    // 身份授权
    handleAuthorization() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          this.httpPut(this.$root.openAgent, this.authorizationForm).then(
            (res) => {
              this.loading--;
              this.authorizationShow = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    handleVipModal(uid, vipNum){
      this.uid = uid;
      this.vipNum = vipNum;
      this.visible1 = true;
      // this.way = way;
    },
    handleTopModal(uid, topNum, way){
      this.uid = uid;
      this.topNum = topNum;
      this.visible2 = true;
      // this.way = way;
    },
    handleConfirm1(){
      this.loading++;
          this.httpPut(this.$root.updateQuota, {
            vipNum: this.vipNum,
            uid: this.uid,
            way: 1
          }).then(
            (res) => {
              this.loading--;
              this.visible1 = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
    },
    handleConfirm2(){
      this.loading++;
          this.httpPut(this.$root.updateQuota, {
            topNum: this.topNum,
            uid: this.uid,
            way: 2
          }).then(
            (res) => {
              this.loading--;
              this.visible2 = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
    },
    addQuotaModal(){
      this.visible3 = true;
    },
    addIntergralModal(){
      this.intergralVisible = true;
    },
    getInfo(){
      this.loading++;
          this.httpGet(this.$root.getQuota, {}).then(
            (res) => {
              this.loading--;
              this.vipAmount = res.vipAmount;
              this.topAmount = res.topAmount;
              this.vipIntegral = res.vipIntegral;
              this.topIntegral = res.topIntegral;
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
    },
    handleConfirm3(){
      this.loading++;
        this.httpPost(this.$root.addQuota, {
          vipAmount: +this.vipAmount || 0,
          topAmount: +this.topAmount || 0,
          // vipIntegral: this.vipIntegral,
          // topIntegral: this.topIntegral,
        }).then(
          (res) => {
            this.loading--;
            this.visible3 = false;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getInfo();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    },
    handleConfirmIntergral(){
      this.loading++;
        this.httpPost(this.$root.addIntergral, {
          vipIntegral: +this.vipIntegral || 0,
          topIntegral: +this.topIntegral || 0,
        }).then(
          (res) => {
            this.loading--;
            this.intergralVisible = false;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getInfo();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.authorization-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      // 表格按钮
      .table-btn-box{
        flex-x(center);
        .table-btn {
          // width: 65px;
          height: 24px;
          line-height: 24px;
          color: gray3;
          font-size: 12px;
          margin-right: 8px;
          cancel-btn();
          padding: 0 8px;
          &:nth-last-of-type(1){
            margin-right: 0
          }
        }
      }

      .filter-item {
        margin-right: 45px;
      }

      .select {
        width: 136px;
      }

      .input {
        width: 125px;
      }

      .date-input {
        width: 350px;
      }

      .btn-box {
        margin: 0;
        margin-left: -20px;
      }

      .authorization-btn {
        confirm-btn();
        height: 32px;
        padding: 0 15px;
        white-space: nowrap;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .authorization-form {
    padding: 16px 0;
    flex-y();

    .input {
      width: 185px;
      height: 32px;
      line-height: 40px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;
      box-sizing: border-box;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }

  .add-hz-form {
    padding-top: 15px;
    flex-y();

    .form-input {
      width: 300px;
      height: 32px;
      margin-left: 3px;
      margin-right: 16px;
      border-radius: 5px;
      padding: 0 12px;
      border: 1px solid #ccc;
      box-sizing: border-box;
      word(13px, #333);
    }
  }
}
</style>
